/**
 * 「보고서 생성」 게이트의 **web 전용 부속** — 판정 자체는 여기 없다.
 *
 * ⚠️ **정본은 `@safetyhub/shared`의 `report-gate`다**(`resolveReportGate`·`signatureProgressLabel`·
 * `ReportGateInput` 등). 2026-10-09에 그리로 올렸다 — 서버가 **집행**(생성 거부)과 목록·스케줄
 * 응답의 판정에 같은 함수를 써야 하기 때문이다. 그 전에는 이 파일이 정본이었고, 그래서 상세가
 * 아닌 진입로 둘(점검 목록 행 메뉴 · 스케줄 페이지)이 **자기 사본**으로 문을 열었다.
 *
 * ⚠️ **이 파일에 게이트 식·사유 문구를 다시 쓰지 말 것.** 여기 남는 것은 DOM 식별자 하나뿐이고,
 * 그것이 web 밖에서는 아무 뜻도 없기 때문에 남아 있다. 되돌림을 잡는 래칫은
 * `__tests__/reportGate.test.ts`(⑦~⑪)다.
 */

/**
 * 「보고서 생성」 비활성 사유를 담는 sr-only 요소의 id — 버튼의 `aria-describedby` 대상.
 *
 * 레이아웃 셋이 같은 값을 쓴다. 중복 id가 되지 않는 근거: `pages/inspections/[id].adaptive.tsx`가
 * `useDeviceLayout()` switch로 **한 레이아웃만 마운트**한다(셋을 동시에 그리지 않는다).
 */
export const REPORT_DISABLED_REASON_ID = 'report-generate-disabled-reason';
